import { render, staticRenderFns } from "./examinationEdit.vue?vue&type=template&id=e6c21bf4&scoped=true&"
import script from "./examinationEdit.vue?vue&type=script&lang=js&"
export * from "./examinationEdit.vue?vue&type=script&lang=js&"
import style0 from "./examinationEdit.vue?vue&type=style&index=0&id=e6c21bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c21bf4",
  null
  
)

export default component.exports